export default {"src":"/_next/static/media/dobrozem-ok.60b57363.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};